import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import apps from './apps/reducers'
import plans from './plans/reducers'
import billingHistory from './billingHistory/reducers'
import ai from './ai/reducers'

export default history =>
  combineReducers({
    router: connectRouter(history),
    settings,
    user,
    menu,
    apps,
    plans,
    billingHistory,
    ai,
  })
